export const securityKey = {

    //** Dashboard */
    DASHBOARD: "Dashboard",
    RUNNINGPROCESS: "Running Process",
    ACTIVESERVER: "Active Server",

    //** Rpa Processes */
    RPAPROCESSES: "Rpa Processes",

    RPAREQUEST: "RPA Request",
    RPAREQUESTOPENTAB: "RPA Request Open Tab",
    RPAREQUESTARCHIVETAB: "RPA Request Archive Tab",
    ADDRPAREQUEST: "Add RPA Request",
    ADDPARTIALREQUEST: "Add Partial Request",
    VIEWRPAREQUEST: "View RPA Request",
    UPDATESTATUSICON: "Update Status Icon",

    RPAREQUESTGROUP: "RPA Request Group",
    RPAREQUESTGROUPOPENTAB: "RPA Request Group Open Tab",
    RPAREQUESTGROUPARCHIVETAB: "RPA Request Group Archive Tab",
    VIEWRPAREQUESTGROUP: "View RPA Request Group",

    MANAGELINKBUILDER: "Manage Link Builder",
    ADDLINKBUILDER: "Add Link Builder",
    VIEWLINKBUILDER: "View Link Builder",
    LINKBUILDEROPENTAB: "Link Builder Open Tab",
    LINKBUILDERARCHIVETAB: "Link Builder Archive Tab",

    //** Database Analyzer */
    DATABASEANALYZER: "Database Analyzer",
    PRICECOMPARISON: "Price Comparison",
    ADDPRICECOMPARISON: "Add Price Comparison",
    PRICEVALIDATION: "Price Validation",
    ADDPRICEVALIDATION: "Add Price Validation",
    STOCKVALIDATION: "Stock Validation",
    ADDSTOCKVALIDATION: "Add Stock Validation",
    DATAANALYZERLIST: "Data Analyzer List",
    DATAANALYZEROPENTAB: "Data Analyzer Open Tab",
    DATAANALYZERARCHIVETAB: "Data Analyzer Archive Tab",
    VIEWDATAANALYZER: "View Data Analyzer",
    SUPPLIERCOMPARISON: "Supplier Comparison",
    SUPPLIERCOMPARISONOPENTAB: "Supplier Comparison Open Tab",
    SUPPLIERCOMPARISONARCHIVETAB: "Supplier Comparison Archive Tab",
    ADDSUPPLIERCOMPARISON: "Add Supplier Comparison",
    VIEWSUPPLIERCOMPARISON: "View Supplier Comparison",

    //** Chemindex */
    CHEMINDEX: "Chemindex",
    PRODUCTDATASYNC: "Product Data Sync",
    PRODUCTDATASYNCOPENTAB: "Product Data Sync Open Tab",
    PRODUCTDATASYNCARCHIVETAB: "Product Data Sync Archive Tab",
    EXPORTPRODUCTDATASYNCREPORT: "Export Product Data Sync Report",
    ADDPRODUCTDATASYNC: "Add Product Data Sync",
    VIEWPRODUCTDATASYNC: "View Product Data Sync",
    DELETEPRODUCTDATASYNC: "Delete Product Data Sync",
    PRODUCTIMPORT: "Product Import",
    PRODUCTIMPORTOPENTAB: "Product Import Open Tab",
    PRODUCTIMPORTARCHIVETAB: "Product Import Archive Tab",
    EXPORTPRODUCTIMPORTREPORT: "Export Product Import Report",
    ADDPRODUCTIMPORT: "Add Product Import",
    VIEWPRODUCTIMPORT: "View Product Import",
    DELETEPRODUCTIMPORT: "Delete Product Import",
    REGULATIONREQUEST: "Regulation Request",
    ADDREGULATIONREQUEST: "Add Regulation Request",
    VIEWREGULATIONREQUEST: "View Regulation Request",
    LINKUPREQUEST: "Linkup Request",
    LINKUPREQUESTOPENTAB: "Linkup Request Open Tab",
    LINKUPREQUESTARCHIVETAB: "Linkup Request Archive Tab",
    ADDLINKUPREQUEST: "Add Linkup Request",
    VIEWLINKUPREQUEST: "View Linkup Request",
    ADDREGULATION:"Add Regulation",
    EDITREGULATION:"Edit Regulation",
    DELETEREGULATION:"Delete Regulation",


    //** Configuration */
    CONFIGURATION: "Configuration",
    RPAMODULES: "RPA Modules",
    ADDRPAMODULES: "Add RPA Modules",
    EDITRPAMODULES: "Edit RPA Modules",
    DELETERPAMODULES: "Delete RPA Modules",
    SERVERCLIENT: "Server Client",
    ADDSERVERCLIENT: "Add Server Client",
    EDITSERVERCLIENT: "Edit Server Client",
    DELETESERVERCLIENT: "Delete Server Client",
    CODEMANAGEMENT: "Code Management",
    ADDCODEMANAGEMENT: "Add Code Management",
    EDITCODEMANAGEMENT: "Edit Code Management",
    DELETECODEMANAGEMENT: "Delete Code Management",
    MANAGESERVER: "Manage Server",
    ADDMANAGESERVER: "Add Manage Server",
    EDITMANAGESERVER: "Edit Manage Server",
    DELETEMANAGESERVER: "Delete Manage Server",

    //** Site Management */
    SITEMANAGEMENT: "Site Management",
    EXCEPTION: "Exception",
    VIEWEXCEPTION: "View Exception",

    //** Email Validation */
    EMAILVALIDATION: "Email Validation",
    ADDEMAILVALIDATION: "Add Email Validation",
    VIEWEMAILVALIDATION: "View Email Validation",

    //** Bingo Product Import */
    BINGOPRODUCTIMPORT: "Bingo Product Import",
    BINGOPRODUCTIMPORTOPENTAB: "Bingo Product Import Open Tab",
    BINGOPRODUCTIMPORTARCHIVETAB: "Bingo Product Import Archive Tab",
    ADDBINGOPRODUCTIMPORT: "Add Bingo Product Import ",
    VIEWBINGOPRODUCTIMPORT: "View Bingo Product Import ",

    //** Image Management */
    IMAGEMANAGEMENT: "Image Management",
    IMAGEMANAGEMENTOPENTAB: "Image Management Open Tab",
    IMAGEMANAGEMENTARCHIVETAB: "Image Management Archive Tab",
    ADDIMAGEMANAGEMENT: "Add Image Management",
    VIEWIMAGEMANAGEMENT: "View Image Management",

    //** Security Permission */
    SECURITYPERMISSION: "SecurityPermission",

    //File Manager
    DELETEFILEMANAGERFILES:"Delete File Manager Files",

    //File Config
    FILECONFIG:"File Config",
    SAVEFILECONFIG:"Save File Config",
}